import {call, put, select, delay, takeLatest} from 'redux-saga/effects';

import {changeField, changeFields} from 'client/common/store/reducers/context/brandlift';
import {setErrors} from 'client/common/store/reducers/errors/brandlift';
import {scrollToError} from 'client/common/store/actions/scroll';

import * as formActions from 'client/common/store/actions/form';

import {getContext} from 'client/common/store/selectors/context';

import {prepareSurveyData} from './survey';

export function* toggleIsCustomFormulations() {
    const {isCustomFormulations} = yield select(getContext);

    if (!isCustomFormulations) {
        const {errors} = yield call(prepareSurveyData);

        if (errors) {
            yield put(setErrors(errors));

            yield delay(1);

            const result: ReturnType<typeof scrollToError> = yield put(scrollToError());

            return result;
        }
    }

    if (isCustomFormulations) {
        yield put(
            changeFields({
                metricOptions: {},
                metricLabels: {},
                metricPlaceholders: {}
            })
        );
    }

    yield put(
        changeField({
            field: 'isCustomFormulations',
            value: !isCustomFormulations
        })
    );
}

export default function* router() {
    yield takeLatest(formActions.toggleIsCustomFormulations.type, toggleIsCustomFormulations);
}
